module.exports = __webpack_public_path__ + "static/agent-e7dced023c1d902ac77f5d65d2411b04.png";